import { Component } from '@angular/core';
import { HomeService } from '../services/home/home.service';
import { AppService } from '../services/app/app.service';
import { CookieService } from 'ngx-cookie-service';
import { Router } from "@angular/router";
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
})
export class HomeComponent {

  public homePageData: any;

  constructor(private readonly homeService: HomeService,
    private cookieService: CookieService,
    private readonly router: Router,
    private appService: AppService) {
    //service.intializeHome();
    this.GetHomePageData();
  }

  GetHomePageData() {

    this.appService.CheckLogin(this.cookieService.get('Login')).subscribe(
      data => {
        if (!data) {
          this.router.navigate(["/login"]);
        }
        else {
          this.homeService.GetHomePageData().subscribe(
            data => {
              this.homePageData = data;
            });
        }
      })
  }
}



// WEBPACK FOOTER //
// ./src/app/home/home.component.ts